var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRole16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87461 18L0.474609 16.6L10.7246 6.35C10.4246 5.65 10.3829 4.85833 10.5996 3.975C10.8163 3.09167 11.2913 2.3 12.0246 1.6C12.9079 0.716667 13.8913 0.2 14.9746 0.05C16.0579 -0.1 16.9413 0.166667 17.6246 0.85C18.3079 1.53333 18.5746 2.41667 18.4246 3.5C18.2746 4.58333 17.7579 5.56667 16.8746 6.45C16.1746 7.18333 15.3829 7.65833 14.4996 7.875C13.6163 8.09167 12.8246 8.05 12.1246 7.75L10.8746 9L18.4746 16.6L17.0746 18L9.47461 10.45L1.87461 18ZM4.82461 9.45L1.82461 6.45C0.924609 5.55 0.474609 4.475 0.474609 3.225C0.474609 1.975 0.924609 0.9 1.82461 0L8.02461 6.25L4.82461 9.45Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole16);
export default __webpack_public_path__ + "static/media/role16.cb866dcb9cbb7d85a14b5bbf806cd6da.svg";
export { ForwardRef as ReactComponent };